export const ObjectMetaDataNameEnum = Object.freeze({
    floorArea:'floorArea',
    foliage:'foliage',
    numberFloor: 'numberFloor',
})